// All transforms from cloudinary docs with their human-readable name and URL
// code
const transformMap = [
  {
    'name': 'angle',
    'transformCode': 'a',
  },
  {
    'name': 'audioCodec',
    'transformCode': 'ac',
  },
  {
    'name': 'audioFrequency',
    'transformCode': 'af',
  },
  {
    'name': 'aspectRatio',
    'transformCode': 'ar',
  },
  {
    'name': 'background',
    'transformCode': 'b',
  },
  {
    'name': 'border',
    'transformCode': 'bo',
  },
  {
    'name': 'bitrate',
    'transformCode': 'br',
  },
  {
    'name': 'cropOrResize',
    'transformCode': 'c',
  },
  {
    'name': 'color',
    'transformCode': 'co',
  },
  {
    'name': 'colorSpace',
    'transformCode': 'cs',
  },
  {
    'name': 'defaultImage',
    'transformCode': 'd',
  },
  {
    'name': 'delay',
    'transformCode': 'dl',
  },
  {
    'name': 'density',
    'transformCode': 'dn',
  },
  {
    'name': 'dpr',
    'transformCode': 'dpr',
  },
  {
    'name': 'duration',
    'transformCode': 'du',
  },
  {
    'name': 'effect',
    'transformCode': 'e',
  },
  {
    'name': 'endOffset',
    'transformCode': 'eo',
  },
  {
    'name': 'format',
    'transformCode': 'f',
  },
  {
    'name': 'flag',
    'transformCode': 'fl',
  },
  {
    'name': 'customFunction',
    'transformCode': 'fn',
  },
  {
    'name': 'fps',
    'transformCode': 'fps',
  },
  {
    'name': 'gravity',
    'transformCode': 'g',
  },
  {
    'name': 'height',
    'transformCode': 'h',
  },
  {
    'name': 'ifCondition',
    'transformCode': 'if',
  },
  {
    'name': 'keyframeInterval',
    'transformCode': 'ki',
  },
  {
    'name': 'layer',
    'transformCode': 'l',
  },
  {
    'name': 'opacity',
    'transformCode': 'o',
  },
  {
    'name': 'prefix',
    'transformCode': 'p',
  },
  {
    'name': 'pageOrFileLayer',
    'transformCode': 'pg',
  },
  {
    'name': 'quality',
    'transformCode': 'q',
  },
  {
    'name': 'roundCorners',
    'transformCode': 'r',
  },
  {
    'name': 'startOffset',
    'transformCode': 'so',
  },
  {
    'name': 'streamingProfile',
    'transformCode': 'sp',
  },
  {
    'name': 'namedTransformation',
    'transformCode': 't',
  },
  {
    'name': 'underlay',
    'transformCode': 'u',
  },
  {
    'name': 'videoCodec',
    'transformCode': 'vc',
  },
  {
    'name': 'videoSampling',
    'transformCode': 'vs',
  },
  {
    'name': 'width',
    'transformCode': 'w',
  },
  {
    'name': 'xCoordinates',
    'transformCode': 'x',
  },
  {
    'name': 'yCoordinates',
    'transformCode': 'y',
  },
  {
    'name': 'zoom',
    'transformCode': 'z',
  },
]

// Get a transform object (from above list) by name
export function getTransformByName(name) {
  return transformMap.find(item => item.name === name)
}

// Get a transform object (from above list) by code
export function getTransformByCode(code) {
  return transformMap.find(item => item.transformCode === code)
}

// Check whether a string is a valid transform code
export function isTransformCode(string) {
  return transformMap.some(item => item.transformCode === string)
}

export default transformMap
